import React from 'react';
import {FormGroup} from "react-bootstrap";

interface NotesFormGroupProps {
  value: string;
  onChange: (notes: string) => void;
}

const NotesFormGroup = (props: NotesFormGroupProps) => {
  const {value, onChange} = props;

  const handleOnChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    onChange(e.target.value);
  }

  return <FormGroup className='mb-4'>
    <label className='fw-bold' htmlFor={'notes'}>Notes</label>
    <textarea className={'form-control'}
              id={'notes'}
              value={value}
              onChange={handleOnChange}
              maxLength={255}
    />
    {/* Optional chaining kept defensively for JS callers that may pass undefined */}
    <p className={'help-block'}>{value?.length || 0}/255</p>
  </FormGroup>
}

export default NotesFormGroup;
